import { Middleware, Dispatch, AnyAction } from 'redux';
import * as Sentry from '@sentry/react';

export const sentryReduxMiddleware: Middleware = () => (next: Dispatch) => (action: AnyAction) => {
    const { meta, error } = action;

    if (meta?.requestStatus === 'rejected') {
        const errorMessage = `Redux Rejection - ${action.type}: ${error.message}`;
        const errorContext = {
            actionType: action.type,
            ...action.payload,
        };

        Sentry.withScope((scope) => {
            scope.setExtras(errorContext);
            scope.setTag('action_type', action.type);
            scope.setFingerprint([action.type, error.message]);
            Sentry.captureException(new Error(errorMessage));
        });
    }

    return next(action);
};
